import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  StyledCheckbox,
  IOSSwitch,
} from './AddComplianceStyleTab';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

export const dataAddCompliance = {
  header: [
    {
      label: 'NO',
      key: 'id',
    },
    {
      label: 'Document Name',
      key: 'document',
    },
    {
      label: 'Type',
      key: 'type',
    },
    {
      label: 'Mandatory',
      key: 'mandatory',
    },
    {
      label: 'Enable/Disable',
      key: "isActive",
    },
    {
      label: '',
      key: 'icon',
    },
  ],
  body: [
    {
      id: '1',
      document: 'SSIC',
      type: 'image',
      mandatory: true,
      enable: true,
      icon: <MoreVertIcon />,
    },
  ],

  addCompliance: [
    {
      placeholder: 'Document Name',
      required: true,
      type: 'text',
      label: 'Document Name',
      star: '*',
    },
  ],
};

export const addCompliance = (data, complianceRegex) => [
  {
    placeholder: 'Document Name',
    required: true,
    type: 'text',
    name: 'docsName',
    label: 'Document Name',
    star: '*',
  },
  {
    placeholder: 'Choose file type',
    required: true,
    type: 'dropdown',
    name: 'type',
    label: 'Type',
    star: '*',
    options:data === 'vehicle' ? [
      { value: 'File', label: 'File' },
      { value: 'text', label: 'Text' },
      { value: 'Multi-Image', label: 'Multi-Image' },
    ] : [
      { value: 'File', label: 'File' },
      { value: 'text', label: 'Text' },
    ],
  },
  {
    placeholder: 'Choose Validation file type',
    required: false,
    type: 'dropdown',
    name: 'validationType',
    label: 'Validation Type',
    star: '*',
    options: [...complianceRegex, {"value": "", label:""}] || []
  },
  {
    radio:true,
    type: 'radio',
    name: 'isExpiring',
    label: 'Expire Date',
    radio: [
      {
        value: 'true',
        label: 'True',
      },
    ],
  },

  {
    type: 'text',
    name: 'isMandatory',
    label: 'Mandatory',
    radio: [
      {
        value: 'true',
        label: 'True',
      },
    ],
  },
];


export const subVendorComplainceData = [
  {
    placeholder: 'Name',
    required: true,
    type: 'text',
    name: 'attributeName',
    label: 'Document Name',
    star: '*',
    countrycode: false,
  }]